import apiConstant from "common/apiConstants";
import reducerConstant from "common/reducerConstants";

import { apiResource } from "../services/api";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  getNotificationsFailed,
  getNotificationsSuccess,
  getUnreadNotificationsCountSuccess,
  markNotificationsAsReadSuccess,
} from "../actions/notificationsActions";
import { toast } from "react-toastify";
import { successContent } from "components/ToastMessage/success";
import { errorContent } from "components/ToastMessage/error";

function* getNotificationsRequest(dObj) {
  try {
    const res = yield call(
      apiResource.get,
      `${apiConstant.notifications}?page=${dObj.payload.page}`
    );
    if (res.success) {
      yield put(
        getNotificationsSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        getNotificationsFailed({
          message: res.data.message,
        })
      );
    }
  } catch (e) {
    yield put(
      getNotificationsFailed({
        message: "Something went wrong",
      })
    );
  }
}

function* getUnreadNotificationsCountRequest() {
  try {
    const res = yield call(
      apiResource.get,
      apiConstant.unreadNotificationsCount
    );
    if (res.success) {
      yield put(
        getUnreadNotificationsCountSuccess({
          response: res.data,
        })
      );
    }
  } catch (e) {}
}

function* markNotificationAsRead() {
  try {
    yield call(apiResource.post, apiConstant.markAsRead, {});
    toast.success(successContent("Marked all notifications as read."));
    yield put(markNotificationsAsReadSuccess());
  } catch (e) {
    toast.error(errorContent("Something went wrong"));
  }
}

function* notificationsSaga() {
  yield takeLatest(reducerConstant.getNotifications, getNotificationsRequest);
  yield takeLatest(
    reducerConstant.getUnreadNotificationsCount,
    getUnreadNotificationsCountRequest
  );
  yield takeLatest(
    reducerConstant.notificationsMarkAsRead,
    markNotificationAsRead
  );
}

export default notificationsSaga;
